import { OpeningHours } from '../../../interfaces/delivery-company/pickups';

const DAYS = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
] as const;

export function ensureOpeningHours(oh?: OpeningHours): OpeningHours {
  return {
    schedule: Object.fromEntries(
      DAYS.map((d) => [d, oh?.schedule?.[d] ?? []])
    ) as OpeningHours['schedule'],
  };
}
export function defaultUtcOffset(): number {
  // JS: minutes = UTC - local; we want local offset hours
  return -new Date().getTimezoneOffset() / 60;
}

